import React from "react";
import { FormattedMessage } from "react-intl";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function StartFocusModeButtonText() {
  const intl_tokens = useIntlTokens();
  return (
    <FormattedMessage
      defaultMessage="Start Focus Mode"
      description="focus mode bottom sheet button start"
      values={{
        FocusMode: intl_tokens.FocusMode,
      }}
    />
  );
}
